import { Money } from 'types';
import { ContentHeading } from 'components/Typography';
import { BottomTotal, PaymentsCard } from 'components/payments/primitives';
import { Payments } from './helpers';
import PaidLineItems from './PaidLineItems';

export interface PaymentSummaryProps {
  transactionAmounts: Payments;
  paidToDateAmounts?: Array<Money>;
}

const PaymentSummary = ({ transactionAmounts, paidToDateAmounts }: PaymentSummaryProps) => (
  <>
    <ContentHeading>Payment summary</ContentHeading>
    <PaymentsCard pb={paidToDateAmounts ? 0 : 1}>
      <PaidLineItems transactionAmounts={transactionAmounts} />
      {paidToDateAmounts && <BottomTotal data-testid="payment-summary-total" title="Total paid to date" totals={paidToDateAmounts} />}
    </PaymentsCard>
  </>
);

export default PaymentSummary;
